"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFixMax = void 0;
exports.getFixMax = function (max, segments) {
    var stepRaw = Math.ceil(max / (segments - 1));
    if (stepRaw < 1) {
        // todo: 0 to 1
        return 1;
    }
    // for > 1
    var roundingUnit = Math.pow(10, Math.min(1, ("" + stepRaw).length - 2)); // 3456 -> 100 , 12345 -> 1000
    var stepRounded = Math.ceil(stepRaw / roundingUnit) * roundingUnit; // 3456 -> 3500, 12435 -> 13000
    return stepRounded * segments;
};
